<template>
  <div id="indexinner">
    <banner :carouselArr="bannerlist"  :Recommendlist2="Recommendlist2">
    </banner>
    <advertisement></advertisement>
    <indexshoplist></indexshoplist>

     <indexnews></indexnews>
  </div>
</template>
<script>
    import banner from '@/components/bannerindex'
    import advertisement from '@/views/index/indexinner/advertisement'
    import indexshoplist from '@/views/index/indexinner/indexshoplist'
    import indexnews from '@/views/index/indexinner/indexnews'
    import qs from "qs";
    export default {
        name: 'indexinner',
        components: {
            banner,
            advertisement,
            indexshoplist,
            indexnews
        },
        data() {
            return {
                //banner数据
                bannerlist: [],
                shopData:{},//banner传输数据
                // //banner广告位数据
                Recommendlist: [{
                    Recommending: require('@/assets/img/su1.png'),
                    linkid: '2'
                }, {
                    Recommending: require('@/assets/img/su2.png'),
                    linkid: '3'
                }],
                Recommendlist1:[],
                Recommendlist2:[],


            }
        },

      created() {
        let that = this;

        if(that.$storage.get('user_data') != null) {
          that.shopData['userrole'] = that.$storage.get('user_data').rank_id
        } else {
          that.shopData['userrole'] = 1
        }

        that.guanggaoFn();
        that.guanggaoFn1();


        // that.getFriend();
      },
      methods: {
        guanggaoFn() {
          let that = this;

          axios({
            method: 'post',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            url: that.$publicUrl.http1 + that.$publicUrl.advertiselist,
            data: qs.stringify({userrole:that.shopData.userrole,type:2}),

          })
            .then(function(response) {
              //						console.log(response);
              let data = response.data;
              if(data.stateCode == 10000) {


                that.bannerlist = data.data;
                // console.log(data)

              } else {
                // that.personalData = {};
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        },
        guanggaoFn1() {
          let that = this;

          axios({
            method: 'post',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            url: that.$publicUrl.http1 + that.$publicUrl.advertiselist,
            data: qs.stringify({userrole:that.shopData.userrole,type:3}),

          })
            .then(function(response) {
              //						console.log(response);
              let data = response.data;
              if(data.stateCode == 10000) {


                // that.Recommendlist1 = data.data;
                that.guanggaoFn2(data.data);

              } else {
                // that.personalData = {};
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        },
        guanggaoFn2(datas) {
          let that = this;

          axios({
            method: 'post',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            url: that.$publicUrl.http1 + that.$publicUrl.advertiselist,
            data: qs.stringify({userrole:that.shopData.userrole,type:4}),

          })
            .then(function(response) {
              //						console.log(response);
              let data = response.data;
              if(data.stateCode == 10000) {

                let arr = [];
                datas[0]['bool'] = 1;
                arr.push(datas[0]);
                let data_ = data.data;
                console.log(data_)
                data_[0]['bool'] = 2;
                arr.push(data_[0]);

                that.Recommendlist2 = arr;
                // console.log(data.data)

              } else {
                // that.personalData = {};
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        },
      },
    }
</script>
<style scoped>
    #indexinner {
        background-color: #f6f6f6;
        padding-bottom: 20px;
    }

    .arry {
        display: block;
        width: 100%;
        height: 60px;
        line-height: 60px;
        text-align: center;
        color: #d81023;
        font-size: 16px;
    }
</style>
